import { render, staticRenderFns } from "./DeviceNotifications.vue?vue&type=template&id=219bd18e"
import script from "./DeviceNotifications.vue?vue&type=script&lang=js"
export * from "./DeviceNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports